import React from 'react';
import agent from '../../../../agent';
import { connect } from 'react-redux';
import ResourceNextBookingWidget from './ResourceNextBookingWidget'
import LoaderWidget from '../Loader/LoaderWidget'
import {checkForUnauthorisedResponse} from '../../../Utils/ErrorHandler'

const mapStateToProps = state => ({
  notification:state.signin.notification
});

class ResourceNextBookingWidgetContainer extends React.Component {

  constructor() {
    super();
    this.state = {
      locations: {},
      loaded:false
    };
  }

  componentDidMount() {
    const dateTime = this.getCurrentTimeAndDate();
    this.loadNextEvents(dateTime.time, dateTime.date);
  }

  componentDidUpdate(prevProps, prevState) {
    this.checkIfResourcesUpdateNeeded(prevProps);
  }

  checkIfResourcesUpdateNeeded(prevProps) {
    const oldNotification = prevProps.notification ? prevProps.notification.notification : null;
    const newNotification = this.props.notification ? this.props.notification.notification : null;
    const oldType = prevProps.notification ? prevProps.notification.type : null;
    const newType = this.props.notification ? this.props.notification.type : null;

    if((!oldNotification && newNotification) ||
       (oldNotification && oldNotification.name !== newNotification.name) ||
       (oldNotification && oldType !== newType))  {
      const dateTime = this.getCurrentTimeAndDate();
      this.loadNextEvents(dateTime.time, dateTime.date);
    }
  }

  getCurrentTimeAndDate() {
    const date = new Date();
    const time = (date.getHours() * 100) + (date.getMinutes());

    return {
      time: time,
      date: date.getDate() + '/' + date.getMonth() + '/' + date.getFullYear()
    }
  }

  loadNextEvents(time, date) {

    agent.MeetingRoom.getNextEventForAllResources(time, date).then(
      res => {
        if(res.result) {

          var resources = {};

          for(var i = 0; i < res.data.length; i++) {
            var resource = res.data[i].resourceName;
            resources[resource] = res.data[i];
          }

          this.setState({
            ...this.state,
            resources:resources,
            loaded:true
          })
        } else {
          this.setState({
            ...this.state,
            'loaded':true
          })
        }
      },
      error => {
        if(!checkForUnauthorisedResponse(error,agent)) {
          this.setState({
            ...this.state,
            'loaded':true
          })
        }
      }
    )

  }

  render() {
    if(this.state.loaded) {
      return (<ResourceNextBookingWidget {...this.props} onWidgetRefresh={this.loadNextEvents.bind(this)} refreshInterval={1800} resources={this.state.resources}/>)
    } else {
      return (
        <LoaderWidget {...this.props}/>
      )
    }
  }
}

export default connect(mapStateToProps)(ResourceNextBookingWidgetContainer);



// WEBPACK FOOTER //
// ./src/components/Dashboard/components/ResourceNextBookingWidget/ResourceNextBookingWidgetContainer.js